module.exports = __webpack_public_path__ + "img/delete.50dee759.svg";